import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeApiResponse, TypeGetReceivingLabelItemsResponse } from '~/types/receive.types';

type LabelItemsParams = {
  ownerCode: string;
  receivingRequestCodes: string;
};

/**
 * [입고요청관리] 라벨 아이템 조회 API
 */
const fetchReceivingLabelItems = async ({ ownerCode, receivingRequestCodes }: LabelItemsParams) => {
  const { data } = await axiosInstance.get<TypeApiResponse<TypeGetReceivingLabelItemsResponse['data']>>(
    `${API_ENDPOINT.RECEIVE_2.GET_RECEIVING_LABEL_ITEMS}/${ownerCode}/items`,
    { params: { receivingRequestCodes } }
  );
  return data.data;
};

/**
 * [입고요청관리] 라벨 아이템 조회 Mutation Hook
 */
export const useGetReceivingLabelItemsMutation = () => {
  return useMutation({
    mutationFn: fetchReceivingLabelItems,
  });
};

const normalResponse: TypeGetReceivingLabelItemsResponse = {
  data: {
    receivingRequestItems: [
      {
        receivingRequestId: 1,
        receivingRequestItemId: 101,
        goodsCode: 'G-1001',
        goodsName: '샘플 상품 A',
        usePallet: false,
        box: 10,
        unitPerBox: 24,
        unit: 240,
        totalUnit: 240,
        label: 10,
      },
      {
        receivingRequestId: 1,
        receivingRequestItemId: 102,
        goodsCode: 'G-1002',
        goodsName: '샘플 상품 B',
        usePallet: true,
        box: 5,
        unitPerBox: 12,
        unit: 60,
        totalUnit: 60,
        label: 5,
      },
    ],
  },
};

registerMockAPI<TypeGetReceivingLabelItemsResponse>({
  method: 'get',
  endpoint: '/api-inbound/v1/kls/receiving-label/:ownerCode/items',
  label: '입고/입고요청/라벨',
  scenarios: [
    { name: '정상 응답', response: normalResponse },
    {
      name: '서버 오류',
      response: { error: { message: '라벨 정보를 불러오는 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
